<template>
  <div :class="pageCls">
    <div class="d1">
      <div class="b1">
        <div class="b2" :style="'width:'+(2.2*userData.sel2.length)+'rem;'">
          <div :key="item" v-for="item in userData.sel2" :d="item" :class="'icon icon_'+item+' icon'+userData.sel1+'_'+item"></div>
        </div>
      </div>
      <div class="b3"></div>
    </div>
    <div class="d2">
      <div class="b1" @click="btnClick"></div>
    </div>
    <div class="d3" v-show="tipShow"></div>
    <div class="d4"></div>
    <div class="d5">
      <div class="b1">
        <img :src="userData.me.tx" >
        <span>{{userData.me.name}}</span>
      </div>
      <div class="b2 ctc"></div>
      <div class="b3 ctc"></div>
      <div class="b4 ctc"></div>
      <div class="b5 ctc"></div>
      <div class="b6 ctc"></div>
      <div class="b7 ctc"></div>
    </div>
    <div class="d6"></div>
    <div class="d7"></div>
    <div class="d8"></div>
  </div>
</template>

<script>
import $ from "jquery";
import Tool from '../script/tool.js'

export default {
  name: 'Page4',
  props: {
    userData: Object
  },
  data(){
    return{
      tipShow:true,
      pageCls:"page4",
      sxArr:{}
    }
  },
  mounted(){
    let that = this;
    let touchTime;
    let touchStatus=0;
    let touchStartL=0;
    let box2MarL = 0;
    let jNum = $(".icon").width()/2;
    let eNum = $(".ctc").width()/2;
    let box = $(".d1 .b1");
    let box2 = $(".d1 .b2");

    //禁止页面拖动
    document.addEventListener('touchmove', function(e) {
      e.preventDefault();
    }, { passive: false });

    $(".icon").on("touchstart",function(event){
      let box = $(this);
      touchStartL = event.touches[0].clientX;
      box2MarL = parseInt(box2.css("marginLeft"));
      touchTime = setTimeout(() => {
        touchStatus = 1;
        box.removeClass("touchend1 touchend2 touchend3 touchend4 touchend5 touchend6");
        box.addClass("touchicon").css({
          left:event.touches[0].clientX - jNum,
          top:event.touches[0].clientY - jNum,
        });
        if(box2MarL < 0){
          let _tem = box2MarL + (jNum*2);
          if(_tem > 0){_tem=0;}
          box2.css("marginLeft",_tem+"px");
        }
      }, 300); 
    });
    $(".icon").on("touchmove",function(event){
      if(touchStatus == 1){
        $(this).addClass("touchicon").css({
          left:event.changedTouches[0].clientX - jNum,
          top:event.changedTouches[0].clientY - jNum,
        });
      }else{
        clearTimeout(touchTime);
        moveSll(event.changedTouches[0].clientX);
      }
    });
    $(".icon").on("touchend",function(event){
      if(touchStatus == 1){
        touchStatus=0;
        let tem = isSave(event.changedTouches[0].clientX,event.changedTouches[0].clientY);
        $(".icon").removeClass("touchend"+tem);
        $(this).removeClass("touchend");
        if(tem > 0){
          that.tipShow=false;
          $(this).addClass("touchend touchend"+tem).css({
            left:$(".ctc").eq(tem-1).offset().left - (jNum - eNum),
            top:$(".ctc").eq(tem-1).offset().top - (jNum - eNum)*0.923,
          });
          that.$emit('playSond',"sel");
          that.sxArr[$(this).attr("d")] = tem;
          $(this).empty().append('<img class="jimgout'+tem+'" src="'+Tool.pubPach+'os/os'+that.userData.sel1+'_'+$(this).attr("d")+'_'+tem+'.png'+'" />');
          setTimeout(() => {
            $(this).find("img").fadeOut();
          }, 3000);
        }
        $(this).removeClass("touchicon");
      }
    });

    
    function moveSll(m){
      //touchStartL
      // console.log(m - touchStartL)
      let ml = box2MarL;
      ml += m - touchStartL;
      if(ml > 0){
        ml = 0;
      }
      if(ml < 0- (box2.width()-box.width())){
        ml = 0- (box2.width()-box.width());
      }
      // console.log(ml)
      box2.css("marginLeft",ml+"px");
    }

    function isSave(clientX,clientY){
      let r = 0;
      $(".ctc").each(function(i){
        let zL = $(this).offset().left+eNum;
        let zT = $(this).offset().top+eNum;
        if((clientX - jNum < zL && zL < clientX + jNum) && (clientY - jNum < zT && zT < clientY + jNum)){
          r = i+1;
        }
      });
      return r;
    }
  },
  methods:{
    btnClick(){
      if(this.userData.sel2.length != $(".touchend").length){
        return false;
      }
      // console.log(this.userData.sel2)
      // console.log(this.sxArr)

      this.pageCls = "page4 page4_2";
      this.$emit('setUser',"sel3",this.sxArr);
      setTimeout(() => {
        this.$emit('setPage',5);
      }, 4500);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$time:0.75;
.page4{
  position: absolute;
  left:0;
  top:0;
  right:0;
  bottom:0;
  *{
    user-select: none;
  }
  .d1{
    position: absolute;
    left:0;
    top:0;
    width: 100%;
    height: 100%;
    background: url(../assets/bg70.png) no-repeat 0 0 / 100% 2.32rem;
    .b1{
      // position: absolute;
      margin-left:1.9rem;
      height: 2.32rem;
      // overflow-x: auto;
      .b2{
        height: 2.32rem;
        div{
          float:left;
        }
      }
    }
    .b3{
      position: absolute;
      left:0;
      top:0;
      width: 1.8rem;
      height: 2.32rem;
      background: url(../assets/bg79.png) no-repeat 0 0 / 100% 100%;
      &::before{
        content: '';
        position: absolute;
        left:0.12rem;
        top:0.78rem;
        width: 1.22rem;
        height: 0.62rem;
        animation:2s linear infinite d1b3Ani;
      }
    }
  }
  .d2{
    position: absolute;
    left:0;
    bottom:0;
    width: 100%;
    height: 1.87rem;
    background: url(../assets/bg74.png) no-repeat 0 0 / 100% 100%;
    // opacity: 0;
    // animation:0.5s 1.5s linear 1 opacityAni2;
    // animation-fill-mode: forwards;
    .b1{
      position: absolute;
      right:0.3rem;
      top:0.5rem;
      width: 3.22rem;
      height: 0.92rem;
      background: url(../assets/bg73.png) no-repeat 0 0 / 100% 100%;
      transform: scale(1.1);
      animation:1s linear infinite transformAni;
    }
  }
  .d3{
    position: absolute;
    right:0.25rem;
    top:2.05rem;
    width: 1.16rem;
    height: 3.67rem;
    background: url(../assets/bg71.png) no-repeat 0 0 / 100% 100%;
    z-index: 1;
  }
  .d4{
    position: absolute;
    left:0.4rem;
    top:2.88rem;
    width: 5.8rem;
    height: 2.44rem;
    background: url(../assets/bg72.png) no-repeat 0 0 / 100% 100%;
    animation:0.5s 2s linear 1 opacityAni;
    animation-fill-mode: forwards;
  }
  .d5{
    position: absolute;
    left:50%;
    top:50%;
    width: 5.58rem;
    height: 8.62rem;
    margin:-3.86rem 0 0 -2.79rem;
    background: url(../assets/bg75.png) no-repeat 0 0 / 100% 100%;
    opacity: 0;
    animation:0.5s 2s linear 1 opacityAni2;
    animation-fill-mode: forwards;
    .b1{
      position: absolute;
      left: 0.36rem;
      top: 0.08rem;
      width: 1.4rem;
      height: 1.4rem;
      transform: scale(1.03);
      img{
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 100%;
      }
      span{
        position: absolute;
        left:-0.43rem;
        bottom:-0.42rem;
        width: 2.26rem;
        height: 0.58rem;
        background: url(../assets/bg76.png) no-repeat 0 0 / 100% 100%;
        font-size: 0.2rem;
        line-height: 0.3rem;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
    }
    .b2{
      position: absolute;
      left:3.75rem;
      top:0.08rem;
      width: 1.4rem;
      height: 1.4rem;
    }
    .b3{
      position: absolute;
      left: 0.39rem;
      top: 3.06rem;
      width: 1.4rem;
      height: 1.4rem;
    }
    .b4{
      position: absolute;
      left:2.075rem;
      top:3.06rem;
      width: 1.4rem;
      height: 1.4rem;
    }
    .b5{
      position: absolute;
      left: 3.81rem;
      top:3.06rem;
      width: 1.4rem;
      height: 1.4rem;
    }
    .b6{
     position: absolute;
      left: 0.355rem;
      top: 6.07rem;
      width: 1.4rem;
      height: 1.4rem;
    }
    .b7{
      position: absolute;
      left:3.755rem;
      top:6.06rem;
      width: 1.4rem;
      height: 1.4rem;
    }
  }
  .touchend1,.touchend2,.touchend3,.touchend4,.touchend5,.touchend6{
    transform: scale(1.03);
  }
}
.page4_2{
  background: #eee;
  .d1{
    background: none;
    z-index: 2;
  }
  .d2,.d1 .b3{
    transform:translate(0);
    animation:0.2s linear 1 opacityAni;
    animation-fill-mode: forwards;
  }
  .d6{
    position: absolute;
    left:0;
    top:50%;
    width: 100%;
    height: 14.08rem;
    margin:-7.04rem 0 0 0;
    background: url(../assets/bg77.png) no-repeat 0 0 / 100% 100%;
    opacity: 0;
    animation:1.9s 0.2s linear 1 opacityAni2;
    animation-fill-mode: forwards;
  }
  .d7{
    position: absolute;
    left:50%;
    top:50%;
    width: 7.29rem;
    height: 12.77rem;
    margin:-6.385rem 0 0 -3.645rem;
    background: url(../assets/bg78.png) no-repeat 0 0 / 100% 100%;
    z-index: 10;
    // opacity: 0;
    // animation:1.9s 2.1s linear 1 opacityAni2;
    // animation-fill-mode: forwards;
    transform: translateY(120vh);
    animation:1.9s 2.1s linear 1 transformAni2;
    animation-fill-mode: forwards;
  }
}

@keyframes d1b3Ani {
  0%{
    background: url(../assets/bg80.png) no-repeat 0 0 / 100% 100%;
  }
  49%{
    background: url(../assets/bg80.png) no-repeat 0 0 / 100% 100%;
  }
  50%{
    background: url(../assets/bg81.png) no-repeat 0 0 / 100% 100%;
  }
  100%{
    background: url(../assets/bg81.png) no-repeat 0 0 / 100% 100%;
  }
}
</style>
